import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { getDriveit } from "../api/api";
import DrawerNavigation from '../utils/DrawerNavigation.js';
import { useMediaQuery } from 'react-responsive';
import myinventory from "../assets/myinventory_mobile_logo.svg";
import myinventoryIcone from '../assets/myinventory-icone.svg';
import atos from '../assets/atos-logo.svg';
import '../styles/App.css';
import '../styles/Buttons.css';
import '../styles/Texts.css';
import '../styles/Alinhamento.css';

function OpcoesDeAcesso() {
  const location = useLocation();
  const [equipamentos, setequipamentos] = useState([]);
  const user = location.state?.user || localStorage.getItem('user');
  const navigate = useNavigate();
  const isBigScreen = useMediaQuery({ query: '(min-width: 481px)' });
  

  useEffect(() => {
    if (!user) {
      navigate('/');
      // eslint-disable-line react-hooks/exhaustive-deps  
    }
    fetchdriveit();
  }, [user]);

  const fetchdriveit = async () => {        
      const response = await getDriveit();        
      const equipamento = response.map((r) => ({
            ...r.fields,
            pk: r.pk
      }));
      setequipamentos(equipamento);
      localStorage.setItem('equipamentos', JSON.stringify(equipamento));
      
        
  };  

  return (
    <>
      
      <header>
      <img src={myinventoryIcone} alt="logo myinventory" className='myinventory-icone' />
      </header>
      <main>
        <div className='conteudo-principal'>
          <p className='texto-principal-da-pagina'>
            Escolha uma das opções abaixo:
          </p>
          <div className='botoes-alinhamento-column'>
            <button className='button-1-claro' onClick={() => navigate('/DriveIT', { state: { user } })} > DriveIT </button>
            {/* <button className='button-1-claro' onClick={() => navigate('/Reflex', { state: { user } })} > Reflex </button> */}
          </div>
          <footer>
            <img src={atos} className='footer-alinhamento-fixed Atos-logo' alt='logo atos'></img>
          </footer>
        </div>
      </main>
    </>
  );
}

export default OpcoesDeAcesso;